/* NHD Oxidative Stress: Your Next Steps. Scoped to #nhd-oxi-next. */
(function(){
  var r=document.getElementById('nhd-oxi-next'); if(!r) return;
  var host=r.closest?r.closest('.shopify-section'):null;
  if(host){host.classList.add('nhd-oxinext-host');}
})();
(function(){
  var root=document.getElementById('nhd-oxi-next'); if(!root) return;
  /* reveal on scroll */
  try{
    if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var rv=Array.prototype.slice.call(root.querySelectorAll('.oxi-card,.oxi-dcard,.oxi-acard,.oxi-head,.oxi-scroll,.oxi-route,.oxi-already div'));
      if(rv.length){
        root.classList.add('oxi-anim');
        rv.forEach(function(el){
          el.classList.add('oxi-rv');
          var sibs=Array.prototype.filter.call(el.parentElement.children,function(c){return c.classList&&c.classList.contains('oxi-rv');});
          var i=sibs.indexOf(el); if(i>0) el.style.setProperty('--nhd-rvd',(Math.min(i,4)*90)+'ms');
        });
        var ticking=false;
        var settle=function(el){
          var d=parseInt((el.style.getPropertyValue('--nhd-rvd')||'0'),10)||0;
          window.setTimeout(function(){el.classList.remove('oxi-rv','oxi-in');el.style.removeProperty('--nhd-rvd');},700+d);
        };
        var tl=root.querySelector('.oxi-tl');
        var check=function(){
          ticking=false;
          var vh=window.innerHeight||0;
          if(tl&&!tl.classList.contains('oxi-tl-on')&&tl.getBoundingClientRect().top<vh-80){
            var nodes=tl.querySelectorAll('.oxi-tl-node');
            for(var n=0;n<nodes.length;n++){nodes[n].style.setProperty('--nhd-tld',(n*160)+'ms');}
            tl.classList.add('oxi-tl-on');
          }
          for(var i=rv.length-1;i>=0;i--){
            var el=rv[i],r=el.getBoundingClientRect();
            if(r.top<vh-40){el.classList.add('oxi-in');settle(el);rv.splice(i,1);}
          }
        };
        var onScroll=function(){if(!ticking){ticking=true;window.requestAnimationFrame(check);}};
        window.addEventListener('scroll',onScroll,{passive:true});
        window.addEventListener('resize',onScroll,{passive:true});
        check();
      }
    }
  }catch(e){root.classList.remove('oxi-anim');}
  var toggle=document.getElementById('oxi-menu-toggle'),links=document.getElementById('oxi-nav-links');
  if(toggle&&links){toggle.addEventListener('click',function(){var open=links.classList.toggle('oxi-open');toggle.setAttribute('aria-expanded',open?'true':'false');});}
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('href').slice(1); if(!id) return;
      var el=document.getElementById(id); if(!el) return;
      e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'start'});
      if(links){links.classList.remove('oxi-open');}
      if(toggle){toggle.setAttribute('aria-expanded','false');}
    });
  });
})();


/* ---------------------------------------------------------------------------
   WebinarJam attribution. Same block as the palpitations testing page.
   Reads wj_user and wj_l from the URL (or the wj_user_product cookie) and
   writes them, plus this page's offer hash, to Shopify cart attributes.
   The WJ Goal Tracking custom pixel reads wj_hash at checkout.
   WJ_OFFER_HASH: the Oxidative Stress webinar offer does not exist yet.
   Paste its 10-character hash here once built (Advanced > Goal tracking).
   While empty, wj_hash is not written and the pixel falls back to 4vr02t1pck
   (Heart Attack Proof), so sales would credit the wrong offer.
--------------------------------------------------------------------------- */
(function () {
  var WJ_OFFER_HASH = ''; /* TODO: Oxidative Stress webinar offer hash */

  function run() {
    var q = new URLSearchParams(window.location.search);
    var user = q.get('wj_user');
    var live = q.get('wj_l') || '';
    if (!user) {
      var m = document.cookie.match(/(?:^|;\s*)wj_user_product=([^;]*)/);
      if (!m) return;
      var v = {};
      decodeURIComponent(m[1]).split('&').forEach(function (p) {
        var kv = p.split('=');
        v[kv[0]] = kv[1];
      });
      user = v.wj_user;
      live = v.wj_l || '';
    }
    if (!user) return;
    var attrs = { wj_user: user, wj_l: live };
    if (WJ_OFFER_HASH) { attrs.wj_hash = WJ_OFFER_HASH; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  if (document.readyState === 'complete') { run(); }
  else { window.addEventListener('load', run); }
})();
